export default {
  'pages.platformSettings.title': 'Platform Settings',
  'pages.platformSettings.tab.branding': 'Branding',
  'pages.platformSettings.tab.llm': 'Default Models',
  'pages.platformSettings.tab.storage': 'Default Storage',
  'pages.platformSettings.tab.quota': 'Usage Limits',
  'pages.platformSettings.tab.features': 'Platform Features',
  'pages.platformSettings.tab.permissions': 'Platform Permissions',
  'pages.platformSettings.subtitle.branding':
    'Set the platform name, logos and copyright.',
  'pages.platformSettings.subtitle.llm':
    'Choose the models the platform uses by default.',
  'pages.platformSettings.subtitle.storage':
    'Set the default storage policy for new apps.',
  'pages.platformSettings.subtitle.quota':
    'Set default quotas and limits for every tenant.',
  'pages.platformSettings.subtitle.features':
    'Turn platform-wide features on or off.',
  'pages.platformSettings.subtitle.permissions':
    'Grant platform-level roles to accounts; tenants no longer manage roles.',
  'pages.platformSettings.save': 'Save',
  'pages.platformSettings.reset': 'Reset',
  'pages.platformSettings.saveSuccess': 'Settings saved',
  'pages.platformSettings.saveFailed': 'Failed to save, please retry',
  'pages.platformSettings.loadFailed': 'Failed to load platform settings',
  'pages.platformSettings.retry': 'Retry',
  'pages.platformSettings.zeroUnlimited': '0 means unlimited',
  'pages.platformSettings.branding.title': 'Platform Branding',
  'pages.platformSettings.branding.description':
    "Branding applies to every user, including pages before sign-in. Name and logos show what this deployment currently uses; leave the footer empty to keep each language's default.",
  'pages.platformSettings.branding.platformName': 'Platform name',
  'pages.platformSettings.branding.platformNameExtra':
    'Shown in the header and browser title',
  'pages.platformSettings.branding.platformNamePlaceholder': 'e.g. CoralReef',
  'pages.platformSettings.branding.platformNameEn': 'English name',
  'pages.platformSettings.branding.logoLight': 'Logo for light theme',
  'pages.platformSettings.branding.logoDark': 'Logo for dark theme',
  'pages.platformSettings.branding.favicon': 'Browser tab icon',
  'pages.platformSettings.branding.footerCopyright': 'Footer copyright',
  'pages.platformSettings.branding.logoHint':
    'PNG, JPG, SVG, WebP or ICO, up to 5 MB',
  'pages.platformSettings.branding.uploadFailed': 'Upload failed, please retry',
  'pages.platformSettings.branding.upload': 'Upload',
  'pages.platformSettings.branding.restoreDefault': 'Restore default',
  'pages.platformSettings.llm.title': 'Default Models',
  'pages.platformSettings.llm.description':
    'Tenants and apps that do not choose a model use these defaults. Options come from enabled built-in models in Model Management.',
  'pages.platformSettings.llm.manageModels': 'Manage models',
  'pages.platformSettings.llm.loadFailed':
    'Failed to load the model catalog; only saved choices are shown',
  'pages.platformSettings.llm.chatModel': 'Default chat model',
  'pages.platformSettings.llm.embeddingModel': 'Default embedding model',
  'pages.platformSettings.llm.notSet': 'Not set',
  'pages.platformSettings.llm.unavailableModel': '{ref} (disabled or missing)',
  'pages.platformSettings.storage.title': 'Default Storage',
  'pages.platformSettings.storage.description':
    'New apps get a storage configuration with these defaults. Existing configurations are unchanged and can be adjusted in App Storage.',
  'pages.platformSettings.storage.autoProvision':
    'Create storage when an app is created',
  'pages.platformSettings.storage.autoProvisionExtra':
    'When off, create it manually in App Storage',
  'pages.platformSettings.storage.accessMode': 'Default access mode',
  'pages.platformSettings.storage.accessMode.private': 'Private',
  'pages.platformSettings.storage.accessMode.public_read': 'Public read',
  'pages.platformSettings.storage.accessMode.public_folder_only':
    'Public folder only',
  'pages.platformSettings.storage.usageEnabled':
    'Enable usage tracking by default',
  'pages.platformSettings.quota.title': 'Tenant Usage Limits',
  'pages.platformSettings.quota.description':
    'Platform-wide defaults for every tenant. Quota from plans and add-ons is added on top of the default.',
  'pages.platformSettings.quota.defaultTenantTokenQuota':
    'Default token quota per tenant',
  'pages.platformSettings.quota.defaultTenantStorageQuotaGb':
    'Default storage quota per tenant',
  'pages.platformSettings.quota.maxMembersPerTenant': 'Max members per tenant',
  'pages.platformSettings.quota.maxInstalledAppsPerTenant':
    'Max self-service apps per tenant',
  'pages.platformSettings.quota.defaultQuotaExtra':
    'Tenants without a quota start with this amount; 0 grants nothing by default',
  'pages.platformSettings.quota.maxInstalledAppsExtra':
    'Counts free apps a tenant activates from the market, excluding plan apps; 0 means unlimited',
  'pages.platformSettings.quota.unitPerson': 'members',
  'pages.platformSettings.quota.unitApp': 'apps',
  'pages.platformSettings.features.title': 'Platform Features',
  'pages.platformSettings.features.aiAssistant': 'Global AI assistant',
  'pages.platformSettings.features.aiAssistantExtra':
    'When off, the floating AI assistant is hidden for everyone',
  'pages.platformSettings.permissions.user': 'Account',
  'pages.platformSettings.permissions.grantedAt': 'Granted at',
  'pages.platformSettings.permissions.actions': 'Actions',
  'pages.platformSettings.permissions.revoke': 'Revoke',
  'pages.platformSettings.permissions.userRequired': 'Select an account',
  'pages.platformSettings.permissions.userPlaceholder':
    'Search by name, username, phone or email',
  'pages.platformSettings.readOnlyHint':
    'You have view-only access to platform settings',
  'pages.platformSettings.permissions.notice':
    'Permissions (resource + view/manage) are granted to roles, and roles to accounts, independent of tenants. Roles and grants live in YeeAuth; changes take effect within 30 seconds.',
  'pages.platformSettings.permissions.roles': 'Roles',
  'pages.platformSettings.permissions.createRole': 'New role',
  'pages.platformSettings.permissions.builtin': 'Built-in',
  'pages.platformSettings.permissions.rename': 'Rename',
  'pages.platformSettings.permissions.deleteRole': 'Delete',
  'pages.platformSettings.permissions.deleteRoleConfirm':
    'Delete role "{name}"? Accounts holding it will lose its permissions.',
  'pages.platformSettings.permissions.deleteRoleSuccess': 'Role deleted',
  'pages.platformSettings.permissions.tabPermissions': 'Permissions',
  'pages.platformSettings.permissions.tabMembers': 'Members',
  'pages.platformSettings.permissions.adminLocked':
    'Platform admins hold every permission; this cannot be changed',
  'pages.platformSettings.permissions.resource': 'Resource',
  'pages.platformSettings.permissions.action.read': 'View',
  'pages.platformSettings.permissions.action.manage': 'Manage',
  'pages.platformSettings.permissions.roleName': 'Role name',
  'pages.platformSettings.permissions.roleNameRequired': 'Enter a role name',
  'pages.platformSettings.permissions.addMember': 'Add member',
  'pages.platformSettings.permissions.empty': 'No members in this role',
  'pages.platformSettings.permissions.revokeConfirm':
    'Remove "{name}" from {role}?',
  'pages.platformSettings.permissions.cannotRevokeSelf':
    'You cannot remove yourself from platform admins',
  'pages.platformSettings.permissions.grantSuccess': 'Member added',
  'pages.platformSettings.permissions.grantFailed': 'Failed to add member',
  'pages.platformSettings.permissions.revokeSuccess': 'Member removed',
  'pages.platformSettings.permissions.loadFailed': 'Failed to load',
  'pages.noPlatformPermission.title': 'No platform access',
  'pages.noPlatformPermission.description':
    'This account has not been granted any platform role. Ask a platform admin for access, then sign in again.',
  'pages.noPlatformPermission.logout': 'Sign out',
  'pages.platformSettings.permissions.group.applications': 'Applications',
  'pages.platformSettings.permissions.group.commercial': 'Sales & marketing',
  'pages.platformSettings.permissions.group.capabilities': 'Platform services',
  'pages.platformSettings.permissions.group.resources': 'Operations',
  'pages.platformSettings.permissions.group.management': 'Platform management',
  'pages.platformSettings.permissions.group.settings': 'Settings',
  'pages.platformSettings.storage.accessMode.inherit':
    'File management default (public folder only)',
};
